export const LANDINGPAGES = [
  'arfbr-digital',
  'grundkurs-proge',
  'rabattaktion-proge-2026',
  'basiskurs-gpa',
  'gewerkschaftsschule-oberoesterreich',
] as const

export type Landingpage = (typeof LANDINGPAGES)[number]

export const DEFAULT_LANDINGPAGE: Landingpage = 'arfbr-digital'

export const isLandingpage = (value: string): value is Landingpage =>
  (LANDINGPAGES as readonly string[]).includes(value)

export const supportsCampaign = (landingpage: Landingpage) => landingpage === 'rabattaktion-proge-2026'
